//TODO: implement
import {connect} from "react-redux";
import BusinessCard from './BusinessCard';
import selectors from '../selectors';

const {getBusinessCard} = selectors;

const mapStateToProps = (state) => {
    return {
        cardConfig: getBusinessCard(state),
        cardUrl: state.app.url
    }
}

export default connect(mapStateToProps,null)(BusinessCard);

